import { render, staticRenderFns } from "./ot-contract-user-details.vue?vue&type=template&id=8f1df32a&scoped=true&"
import script from "./ot-contract-user-details.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-user-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-user-details.vue?vue&type=style&index=0&id=8f1df32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1df32a",
  null
  
)

export default component.exports